import { auth } from "../firebase.config";

const getUsername = () => {
  return auth.currentUser?.displayName;
};

export default getUsername;
